/* BDEF-CUSTOM - Bicos de Fio (bicosdefio.com) / Prestige 10.7.0 */
/* ============================================================
   FREE SHIPPING BAR
   ============================================================ */

async function bdefInitShippingBar() {
  var bar = document.querySelector('free-shipping-bar');
  if (!bar) return;

  if (!bar.querySelector('.bdef-bar__track')) {
    var track = document.createElement('div');
    track.className = 'bdef-bar__track';
    var fill = document.createElement('div');
    fill.className = 'bdef-bar__fill';
    track.appendChild(fill);
    bar.appendChild(track);
    new MutationObserver(function() { bdefRenderBar(bar); })
      .observe(bar, { attributes: true, attributeFilter: ['total-price'] });
    var span = bar.querySelector('span');
    if (span) {
      new MutationObserver(function() { bdefStyleShippingText(span); })
        .observe(span, { childList: true, subtree: true, characterData: true });
      bdefStyleShippingText(span);
    }
  }

  var rawPrice = bar.getAttribute('total-price');
  if (!rawPrice || rawPrice === 'NaN' || rawPrice === 'null') {
    try {
      var cart = await fetch('/cart.js').then(function(r) { return r.json(); });
      var total = cart.items
        .filter(function(i) { return i.requires_shipping; })
        .reduce(function(s, i) { return s + i.final_line_price; }, 0);
      var disc = (cart.cart_level_discount_applications || [])
        .reduce(function(s, d) { return s + d.total_allocated_amount; }, 0);
      bar.setAttribute('total-price', String(total - disc));
    } catch(e) {
      bar.setAttribute('total-price', '0');
    }
  }
  bdefRenderBar(bar);
}

function bdefRenderBar(bar) {
  var threshold  = parseFloat(bar.getAttribute('threshold'));
  var totalPrice = parseFloat(bar.getAttribute('total-price')) || 0;
  if (!threshold) return;
  var fill = bar.querySelector('.bdef-bar__fill');
  if (!fill) return;
  var pct = Math.min((totalPrice / threshold) * 100, 100);
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      fill.style.width = pct + '%';
      fill.style.backgroundColor = bdefBarColor(pct);
      bar.classList.toggle('bdef-bar--reached', totalPrice >= threshold);
      var span = bar.querySelector('span');
      if (span) bdefStyleShippingText(span);
    });
  });
}

/* Resalta importe y ENVIO GRATIS/GRATUITO en el texto del componente nativo.
   USA textContent (no innerHTML) para evitar el bug de &nbsp; que rompe el regex. */
function bdefStyleShippingText(span) {
  if (!span) return;
  if (span.querySelector('.bdef-bar__hl')) return;
  var text = span.textContent;
  if (!text.trim()) return;
  var html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  html = html.replace(/(\d[\d.,\u00a0\u202f ]*\u20ac)/g,
    '<strong class="bdef-bar__hl">$1</strong>');
  html = html.replace(/(env[\u00edi]o\s+grat(?:is|uito))/gi, function(match) {
    return '<strong class="bdef-bar__hl">' + match.toUpperCase() + '</strong>';
  });
  span.innerHTML = html;
}

/* Color gradual: 0% rojo -> 50% ambar -> 100% verde */
function bdefBarColor(pct) {
  var r, g, b, t;
  if (pct <= 50) {
    t = pct / 50;
    r = Math.round(224 + (232 - 224) * t);
    g = Math.round(82  + (193 - 82)  * t);
    b = Math.round(82  + (61  - 82)  * t);
  } else {
    t = (pct - 50) / 50;
    r = Math.round(232 + (82  - 232) * t);
    g = Math.round(193 + (184 - 193) * t);
    b = Math.round(61  + (136 - 61)  * t);
  }
  return 'rgb(' + r + ',' + g + ',' + b + ')';
}

document.addEventListener('DOMContentLoaded', function() {

  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    /* dialog:after-show: cubre apertura del drawer con o sin cambios de carrito.
       bdefInitShippingBar es idempotente: si el track ya existe solo actualiza valores.
       Reemplaza el IntersectionObserver que observaba el elemento original (detachado
       despues de cualquier cart-drawer:refreshed). */
    cartDrawer.addEventListener('dialog:after-show', function() {
      bdefInitShippingBar();
      bdefLoadRecommendations();
    });
  }

  /* cart-drawer:refreshed: cubre cambios de carrito (anadir, eliminar, cantidad) */
  document.addEventListener('cart-drawer:refreshed', bdefInitShippingBar);
  document.addEventListener('cart-drawer:refreshed', bdefLoadRecommendations);

});


/* =============================================================================
   CART RECOMMENDATIONS

   Detección de género (3 fuentes en orden de fiabilidad):
     1. Tags del producto ("Hombre", "Mujer", "Unisex")     — más fiable
     2. _sourceGender del handle de colección (PASO 3)       — fiable
     3. Keywords en product_type / title (cart items)        — fallback

   Estrategia de 3 pasos (totalmente paralelizada):
     PASO 1: intent=complementary — S&D manual, prioridad editorial
     PASO 2: intent=related       — ML Shopify, multi-seed
     PASO 3: colecciones cruzadas — diversidad garantizada por categoría y género

     PASO 1 y PASO 2 se lanzan en paralelo con Promise.all.
     PASO 3 se lanza en paralelo (4 fetches simultáneos) una vez conocido el género.

   Filtros (en orden):
     1. Género (hard)
     2. Vendor cap (máx 3 por marca)
     3. Product_type cap (máx 2 por categoría semántica)
     4. Talla (soft: si ≥3 tienen talla del carrito, priorizar)
   ============================================================================= */

/* ─── Constantes ─── */
var BDEF_VENDOR_CAP        = 3;
var BDEF_TYPE_CAP          = 2;
var BDEF_MAX_RECS          = 5;
var BDEF_MAX_CROSS_FETCHES = 4;
var BDEF_CROSS_MIN_POOL    = 8;    /* pool mínimo antes de activar PASO 3 */
var BDEF_CROSS_DOMINANCE   = 0.6;  /* umbral: >60% del mismo tipo → activar PASO 3 */

/* ─── Colecciones cruzadas por género y categoría ─── */
var BDEF_CROSS_MAP = {
  male: {
    tops:       ['bermudas-y-shorts-hombre','jeans-hombre','pantalones-hombre','zapatillas-hombre','calcetines-hombre','gorras-y-gorros-hombre','cinturones-hombre'],
    shirts:     ['jeans-hombre','pantalones-hombre','zapatillas-hombre','chaquetas-y-cazadoras-hombre','cinturones-hombre','bolsos-y-mochilas-hombre'],
    jeans:      ['camisetas-hombre','camisas','polos-hombre','zapatillas-hombre','cinturones-hombre','calcetines-hombre','chaquetas-y-cazadoras-hombre'],
    pants:      ['camisetas-hombre','camisas','polos-hombre','zapatillas-hombre','cinturones-hombre','calcetines-hombre'],
    shorts:     ['camisetas-hombre','polos-hombre','camisas','zapatillas-hombre','chanclas-y-sandalias-hombre','calcetines-hombre','gorras-y-gorros-hombre'],
    swimwear:   ['chanclas-y-sandalias-hombre','camisetas-hombre','gorras-y-gorros-hombre','bolsos-y-mochilas-hombre'],
    sportpants: ['zapatillas-hombre','sudaderas-hombre','camisetas-hombre','calcetines-hombre'],
    outerwear:  ['jeans-hombre','camisetas-hombre','zapatillas-hombre','gorras-y-gorros-hombre','calcetines-hombre'],
    jackets:    ['jeans-hombre','camisetas-hombre','camisas','zapatillas-hombre','gorras-y-gorros-hombre','bufandas-y-foulards-hombre'],
    coats:      ['jeans-hombre','camisas','zapatillas-hombre','bufandas-y-foulards-hombre','gorras-y-gorros-hombre','carteras-y-billeteras-hombre'],
    suits:      ['camisas','zapatillas-hombre','cinturones-hombre','carteras-y-billeteras-hombre','complementos-hombre'],
    footwear:   ['camisetas-hombre','jeans-hombre','bermudas-y-shorts-hombre','calcetines-hombre','gorras-y-gorros-hombre'],
    accessories:['camisetas-hombre','jeans-hombre','zapatillas-hombre','bermudas-y-shorts-hombre'],
    def:        ['camisetas-hombre','jeans-hombre','zapatillas-hombre','bermudas-y-shorts-hombre','complementos-hombre']
  },
  female: {
    tops:       ['jeans-mujer','pantalones-mujer','shorts-y-bermudas-mujer','faldas','zapatillas-mujer','bolsos-mujer','complementos-mujer'],
    shirts:     ['jeans-mujer','pantalones-mujer','faldas','zapatillas-mujer','bolsos-mujer','cinturones-mujer'],
    jeans:      ['camisetas-y-tops','camisas-y-blusas','zapatillas-mujer','bolsos-mujer','cinturones-mujer','chaquetas-y-cazadoras-mujer'],
    pants:      ['camisetas-y-tops','camisas-y-blusas','zapatillas-mujer','bolsos-mujer','cinturones-mujer'],
    shorts:     ['camisetas-y-tops','camisas-y-blusas','zapatillas-mujer','chanclas-mujer','bolsos-mujer','complementos-mujer'],
    swimwear:   ['chanclas-mujer','bolsos-mujer','zapatillas-mujer','neceseres-mujer','complementos-mujer'],
    sportpants: ['zapatillas-mujer','sudaderas-mujer','camisetas-y-tops','calcetines-mujer'],
    outerwear:  ['jeans-mujer','camisetas-y-tops','zapatillas-mujer','bolsos-mujer','bufandas-y-foulards-mujer'],
    jackets:    ['jeans-mujer','camisetas-y-tops','camisas-y-blusas','zapatillas-mujer','bolsos-mujer','bufandas-y-foulards-mujer'],
    coats:      ['jeans-mujer','camisas-y-blusas','zapatillas-mujer','bolsos-mujer','bufandas-y-foulards-mujer','gorras-y-gorros-mujer'],
    dresses:    ['zapatillas-mujer','sandalias-y-zapatos-mujer','bolsos-mujer','cinturones-mujer','collares-y-chokers-mujer','complementos-mujer'],
    skirts:     ['camisetas-y-tops','camisas-y-blusas','zapatillas-mujer','sandalias-y-zapatos-mujer','bolsos-mujer'],
    footwear:   ['camisetas-y-tops','jeans-mujer','shorts-y-bermudas-mujer','faldas','bolsos-mujer','complementos-mujer'],
    accessories:['camisetas-y-tops','jeans-mujer','zapatillas-mujer','vestidos','shorts-y-bermudas-mujer'],
    def:        ['camisetas-y-tops','jeans-mujer','zapatillas-mujer','bolsos-mujer','complementos-mujer']
  }
};

/* Handles sin "hombre"/"mujer" en el nombre — derivado del menú real */
var BDEF_COLLECTION_GENDER = {
  'camisas':               'male',
  'ropa-interior':         'male',
  'camisetas-y-tops':      'female',
  'camisas-y-blusas':      'female',
  'faldas':                'female',
  'vestidos':              'female',
  'monos':                 'female',
  'sujetadores-deportivos':'female',
  'panuelos':              'female'
};

/* ─── Regex precompiladas ─── */
var BDEF_RE_MONEY    = /(\d[\d.,\u00a0\u202f ]*\u20ac)/g;
var BDEF_RE_SHIPPING = /(env[\u00edi]o\s+grat(?:is|uito))/gi;

/* ─── Formatter cacheado ─── */
var bdefMoneyFmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

/* ─── Estado global ─── */
var bdefCartSizes      = [];
var bdefCartGender     = null;
var bdefCartSizeGender = {};
var bdefRecsLoading    = false;

/* ─── Utilidades ─── */

function bdefNormText(s) {
  return (s || '').toLowerCase()
    .replace(/[áàâã]/g,'a').replace(/[éèê]/g,'e')
    .replace(/[íìî]/g,'i').replace(/[óòôõ]/g,'o')
    .replace(/[úùû]/g,'u').replace(/[ñ]/g,'n').replace(/[ü]/g,'u');
}

function bdefEscapeHtml(s) {
  return (s || '')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function bdefFormatMoney(cents) {
  return bdefMoneyFmt.format(cents / 100);
}

/* Solicita al CDN de Shopify el tamaño exacto de imagen (2x para retina).
   Añade width= a URLs de Shopify CDN; devuelve la URL sin cambios si no es CDN. */
function bdefResizeImage(url, width) {
  if (!url) return '';
  var sep = url.indexOf('?') !== -1 ? '&' : '?';
  return url + sep + 'width=' + width;
}
function bdefPriceHTML(price, comparePrice) {
  if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
    return '<span class="bdef-recs__price-sale">'    + bdefFormatMoney(price)        + '</span>' +
           '<span class="bdef-recs__price-compare">' + bdefFormatMoney(comparePrice) + '</span>';
  }
  return bdefFormatMoney(price);
}

/* ─── Género: cart items (sin tags, usa keywords) ─── */
function bdefDetectCartGender(items) {
  var m = 0, f = 0;
  var MKW = ['hombre','caballero','homme','masculin','boy','chico'];
  var FKW = ['mujer','senora','femme','feminin','girl','chica','dama'];
  items.forEach(function(item) {
    var t = bdefNormText((item.product_type || '') + ' ' + (item.title || ''));
    MKW.forEach(function(k) { if (t.indexOf(k) !== -1) m++; });
    FKW.forEach(function(k) { if (t.indexOf(k) !== -1) f++; });
    if (/\b(man|men|male)\b/.test(t))       m++;
    if (/\b(woman|women|female)\b/.test(t)) f++;
  });
  if (!m && !f) return null;
  return m >= f ? 'male' : 'female';
}

/* ─── Género: productos recomendados (tags > _sourceGender > product_type) ─── */
function bdefProductMatchesGender(product, gender) {
  if (!gender) return true;
  if (product._sourceGender) return product._sourceGender === gender;
  var tags = (Array.isArray(product.tags) ? product.tags : [])
    .map(function(t) { return bdefNormText(t); });
  if (tags.indexOf('unisex') !== -1)  return true;
  if (tags.indexOf('hombre') !== -1)  return gender === 'male';
  if (tags.indexOf('mujer')  !== -1)  return gender === 'female';
  var pt = bdefNormText(product.product_type || '');
  var hasMale = pt.indexOf('hombre') !== -1;
  var hasFem  = pt.indexOf('mujer')  !== -1;
  if (!hasMale && !hasFem) return true;
  return gender === 'male' ? hasMale : hasFem;
}

/* ─── Inferencia de género desde un pool de productos (tags + _sourceGender) ─── */
function bdefInferGenderFromPool(pool) {
  var m = 0, f = 0;
  pool.forEach(function(p) {
    if      (p._sourceGender === 'male')   m++;
    else if (p._sourceGender === 'female') f++;
    else {
      var tags = (Array.isArray(p.tags) ? p.tags : []).map(bdefNormText);
      if      (tags.indexOf('hombre') !== -1) m++;
      else if (tags.indexOf('mujer')  !== -1) f++;
    }
  });
  if (m === f) return null;
  return m > f ? 'male' : 'female';
}


/* Detecta el sistema de tallas de un array de option1:
   'clothing' (XS/S/M/L/XL…), 'footwear' (36-49),
   'denim' (W30, W30/L32…), 'other' (Única, accesorios) */
function bdefSizeSystem(sizes) {
  var clothing = /^(xs|s|m|l|xl|xxl|xxxl|2xl|3xl)$/i;
  var footwear = /^([23][0-9]|4[0-9])$/;
  var denim    = /^w\d+/i;
  for (var i = 0; i < sizes.length; i++) {
    if (clothing.test(sizes[i])) return 'clothing';
    if (footwear.test(sizes[i])) return 'footwear';
    if (denim.test(sizes[i]))    return 'denim';
  }
  return 'other';
}
function bdefProductHasCartSize(product) {
  if (!bdefCartSizes.length) return true;
  return product.variants.some(function(v) {
    return bdefCartSizes.indexOf(v.option1) !== -1 && v.available;
  });
}

/* ─── Detección de categorías del carrito ─── */
function bdefDetectCartCategories(items) {
  var cats = {};
  items.forEach(function(item) {
    var t = bdefNormText(item.product_type || '');
    if (/camiseta|polo|top/.test(t))                                             cats.tops       = true;
    if (/camisa|blusa/.test(t))                                                  cats.shirts     = true;
    if (/\bjean|vaquero/.test(t))                                                cats.jeans      = true;
    if (/pantalon(?!.*deport)/.test(t) && !/jean|vaquero|legging|corto/.test(t)) cats.pants     = true;
    if (/short|bermuda/.test(t) || (/corto/.test(t) && /pantalon/.test(t)))     cats.shorts     = true;
    if (/banador|bikini/.test(t))                                                cats.swimwear   = true;
    if (/deportiv|legging|sport/.test(t))                                        cats.sportpants = true;
    if (/sudadera|jersey|cardigan|chaleco/.test(t))                              cats.outerwear  = true;
    if (/chaqueta|cazadora/.test(t))                                             cats.jackets    = true;
    if (/abrigo|parka/.test(t))                                                  cats.coats      = true;
    if (/\btraje/.test(t))                                                       cats.suits      = true;
    if (/vestido|mono(?!.*ciclista)/.test(t))                                    cats.dresses    = true;
    if (/\bfalda/.test(t))                                                       cats.skirts     = true;
    if (/zapatilla|bota|botin|sandalia|chancla|alpargata|calzado|zapato/.test(t)) cats.footwear  = true;
    if (/complemento|cinturon|bolso|mochila|cartera|calcetine|gorra|pulsera|collar|pendiente|bufanda|gafa|media|paraguas|llavero|interior|neceser/.test(t)) cats.accessories = true;
  });
  return Object.keys(cats);
}

/* ─── Colecciones cruzadas ─── */
function bdefHandleGender(handle) {
  if (BDEF_COLLECTION_GENDER[handle]) return BDEF_COLLECTION_GENDER[handle];
  if (handle.indexOf('hombre') !== -1) return 'male';
  if (handle.indexOf('mujer')  !== -1) return 'female';
  return null;
}

function bdefVoteGender(handles) {
  var m = 0, f = 0;
  handles.forEach(function(h) {
    var g = bdefHandleGender(h);
    if (g === 'male')   m++;
    else if (g === 'female') f++;
  });
  if (m === f) return null;
  return m > f ? 'male' : 'female';
}

function bdefGetCrossHandles(gender, cartCategories) {
  function handlesForGender(gKey) {
    var map = BDEF_CROSS_MAP[gKey];
    var seen = {}, result = [];
    cartCategories.forEach(function(cat) {
      (map[cat] || map.def).forEach(function(h) {
        if (!seen[h]) { seen[h] = true; result.push(h); }
      });
    });
    if (!result.length) {
      map.def.forEach(function(h) {
        if (!seen[h]) { seen[h] = true; result.push(h); }
      });
    }
    return result;
  }

  if (gender === 'male' || gender === 'female') {
    var handles = handlesForGender(gender);
    /* Fisher-Yates shuffle para variar el orden en cada sesión */
    for (var j = handles.length - 1; j > 0; j--) {
      var rnd = Math.floor(Math.random() * (j + 1));
      var tmp = handles[j]; handles[j] = handles[rnd]; handles[rnd] = tmp;
    }
    return handles;
  }

  /* Gender desconocido: interleave male-first sin shuffle
     → orden determinista para que bdefVoteGender sea consistente */
  var mH = handlesForGender('male');
  var fH = handlesForGender('female');
  var seen2 = {}, merged = [];
  var max = Math.max(mH.length, fH.length);
  for (var i = 0; i < max; i++) {
    if (mH[i] && !seen2[mH[i]]) { seen2[mH[i]] = true; merged.push(mH[i]); }
    if (fH[i] && !seen2[fH[i]]) { seen2[fH[i]] = true; merged.push(fH[i]); }
  }
  return merged;
}

/* ─── Normalización de productos de collections API ─── */
function bdefNormalizeCollectionProduct(p, sourceGender) {
  return {
    id:             p.id,
    title:          p.title,
    vendor:         p.vendor,
    product_type:   p.product_type,
    tags:           p.tags || [],
    url:            '/products/' + p.handle,
    featured_image: p.images && p.images[0] ? p.images[0].src : '',
    _sourceGender:  sourceGender || null,
    variants: (p.variants || []).map(function(v) {
      return {
        id:               v.id,
        option1:          v.option1,
        price:            Math.round(parseFloat(v.price) * 100),
        compare_at_price: v.compare_at_price
                            ? Math.round(parseFloat(v.compare_at_price) * 100)
                            : null,
        available:        v.available
      };
    })
  };
}

/* ─── Motor de recomendaciones ─── */
async function bdefLoadRecommendations() {
  if (bdefRecsLoading) return;
  bdefRecsLoading = true;

  var container = document.getElementById('bdef-cart-recs');
  if (!container) { bdefRecsLoading = false; return; }

  try {
    var cart;
    try { cart = await fetch('/cart.js').then(function(r) { return r.json(); }); }
    catch(e) { return; }

    if (!cart.items.length) { container.hidden = true; return; }

    /* Resetear estado global */
    bdefCartGender     = null;
    bdefCartSizeGender = {};
    bdefCartSizes = cart.items
      .map(function(item) { return (item.variant_title || '').split(' / ')[0].trim(); })
      .filter(function(s, idx, arr) { return s && s !== 'Default Title' && arr.indexOf(s) === idx; });

    cart.items.forEach(function(item) {
      var size = (item.variant_title || '').split(' / ')[0].trim();
      if (size && size !== 'Default Title') {
        bdefCartSizeGender[size] = bdefDetectCartGender([item]);
      }
    });

    bdefCartGender = bdefDetectCartGender(cart.items);

    var cartProductIds = cart.items.map(function(i) { return i.product_id; });
    var seenIds  = {};
    var combined = [];

    /* Función auxiliar: fetch seguro que nunca rechaza */
    function safeFetch(url) {
      return fetch(url).then(function(r) { return r.json(); })
        .catch(function() { return { products: [] }; });
    }

    /* ── PASO 1 + PASO 2 en paralelo ──────────────────────────────────────────
       Se lanzan TODOS los fetches simultáneamente.
       Los resultados se procesan en orden de prioridad:
         1º complementary (editorial), 2º related (ML)
       garantizando que complementary ocupa las primeras posiciones del pool.    */
    var allResults = await Promise.all([
      /* PASO 1: un fetch por item */
      Promise.all(cart.items.map(function(item) {
        return safeFetch(
          '/recommendations/products.json?product_id=' +
          item.product_id + '&limit=10&intent=complementary'
        );
      })),
      /* PASO 2: un fetch por item */
      Promise.all(cart.items.map(function(item) {
        return safeFetch(
          '/recommendations/products.json?product_id=' +
          item.product_id + '&limit=10&intent=related'
        );
      }))
    ]);

    var complementaryResults = allResults[0];
    var relatedResults       = allResults[1];

    /* Procesar PASO 1: usar resultados del primer item que tenga complementarios */
    for (var i = 0; i < complementaryResults.length; i++) {
      var added = 0;
      (complementaryResults[i].products || []).forEach(function(p) {
        if (!cartProductIds.includes(p.id) && !seenIds[p.id]) {
          seenIds[p.id] = true; combined.push(p); added++;
        }
      });
      if (added > 0) break;
    }

    /* Procesar PASO 2: añadir todos los related no duplicados */
    relatedResults.forEach(function(r2) {
      (r2.products || []).forEach(function(p) {
        if (!cartProductIds.includes(p.id) && !seenIds[p.id]) {
          seenIds[p.id] = true; combined.push(p);
        }
      });
    });

    /* Inferir género del pool si el carrito no lo revelaba */
    if (!bdefCartGender && combined.length > 0) {
      bdefCartGender = bdefInferGenderFromPool(combined);
    }

    /* ── PASO 3: colecciones cruzadas ─────────────────────────────────────────
       Activa si el pool es pequeño (<BDEF_CROSS_MIN_POOL) o poco diverso
       (un solo tipo supera el BDEF_CROSS_DOMINANCE del pool).
       Todos los fetches de colecciones se lanzan en paralelo.                   */
    var needsCross = combined.length < BDEF_CROSS_MIN_POOL;
    if (!needsCross && combined.length > 0) {
      var types = {};
      combined.forEach(function(p) {
        var t = p.product_type || '';
        types[t] = (types[t] || 0) + 1;
      });
      var dominant = Math.max.apply(null, Object.values(types));
      needsCross = dominant >= combined.length * BDEF_CROSS_DOMINANCE;
    }

    if (needsCross) {
      var cartCats     = bdefDetectCartCategories(cart.items);
      var crossHandles = bdefGetCrossHandles(bdefCartGender, cartCats);

      if (!bdefCartGender) bdefCartGender = bdefVoteGender(crossHandles);

      /* Seleccionar los primeros BDEF_MAX_CROSS_FETCHES handles válidos */
      var crossToFetch = [];
      for (var k = 0; k < crossHandles.length && crossToFetch.length < BDEF_MAX_CROSS_FETCHES; k++) {
        var hg = bdefHandleGender(crossHandles[k]);
        if (!bdefCartGender || !hg || hg === bdefCartGender) {
          crossToFetch.push({ handle: crossHandles[k], gender: hg });
        }
      }

      /* Lanzar todos los fetches de colecciones en paralelo */
      var crossResults = await Promise.all(crossToFetch.map(function(item) {
        return safeFetch('/collections/' + item.handle + '/products.json?limit=5')
          .then(function(data) {
            return { products: data.products || [], gender: item.gender };
          });
      }));

      crossResults.forEach(function(result) {
        result.products.forEach(function(p) {
          var norm = bdefNormalizeCollectionProduct(p, result.gender);
          if (!cartProductIds.includes(norm.id) && !seenIds[norm.id]) {
            seenIds[norm.id] = true; combined.push(norm);
          }
        });
      });

      /* Última oportunidad para inferir género (con los productos de colecciones) */
      if (!bdefCartGender && combined.length > 0) {
        bdefCartGender = bdefInferGenderFromPool(combined);
      }
    }

    /* ── Filtros ───────────────────────────────────────────────────────────── */

    /* 0. Eliminar productos completamente agotados */
    combined = combined.filter(function(p) {
      return (p.variants || []).some(function(v) { return v.available; });
    });

    /* 1. Género (hard) */
    var recs = combined.filter(function(p) {
      return bdefProductMatchesGender(p, bdefCartGender);
    });

    /* 2. Vendor cap */
    var vendorCount = {};
    recs = recs.filter(function(p) {
      var v = bdefNormText(p.vendor || '');
      vendorCount[v] = (vendorCount[v] || 0) + 1;
      return vendorCount[v] <= BDEF_VENDOR_CAP;
    });

    /* 3. Product_type cap con bucketing semántico */
    var typeCount = {};
    recs = recs.filter(function(p) {
      var cats = bdefDetectCartCategories([{ product_type: p.product_type || '' }]);
      var key  = cats.length ? cats[0] : bdefNormText(p.product_type || 'other');
      typeCount[key] = (typeCount[key] || 0) + 1;
      return typeCount[key] <= BDEF_TYPE_CAP;
    });

    /* Talla (soft): priorizar productos con la talla del carrito disponible.
       Lógica por sistema de tallas para no penalizar cross-sells:
         - Match exacto (talla disponible) → siempre incluir
         - Sistema 'other' (bolsos, accesorios, talla única) → siempre incluir
         - Sistema distinto al del carrito (calzado cuando carrito=ropa) → incluir
         - Mismo sistema sin la talla del carrito → excluir */
    if (bdefCartSizes.length > 0) {
      var bySize = recs.filter(function(p) {
        /* 1. Tiene alguna talla del carrito disponible → prioridad máxima */
        if (p.variants.some(function(v) {
          return bdefCartSizes.indexOf(v.option1) !== -1 && v.available;
        })) return true;
        /* 2. Accesorios/bolsos/talla única → siempre incluir */
        var productSys = bdefSizeSystem(p.variants.map(function(v) { return v.option1 || ''; }));
        if (productSys === 'other') return true;
        /* 3. El carrito no tiene ninguna talla de este sistema → cross-sell, incluir */
        return !bdefCartSizes.some(function(s) {
          return bdefSizeSystem([s]) === productSys;
        });
      });
      if (bySize.length >= 3) recs = bySize;
    }

    recs = recs.slice(0, BDEF_MAX_RECS);
    if (!recs.length) { container.hidden = true; return; }

    container.innerHTML = bdefBuildRecsHTML(recs);
    container.hidden    = false;
    bdefBindRecsEvents(container);

  } finally {
    bdefRecsLoading = false;
  }
}

/* ─── Construcción del HTML ─── */

function bdefBuildRecsHTML(products) {
  return '<div class="bdef-recs__inner">' +
    '<p class="bdef-recs__heading">Esto te puede gustar</p>' +
    '<ul class="bdef-recs__list" role="list">' +
    products.map(bdefBuildRecItem).join('') +
    '</ul></div>';
}

function bdefBuildRecItem(product) {
  var variants = product.variants;
  if (!variants || !variants.length) return '';

  var baseVariant = variants.find(function(v) { return v.available; }) || variants[0];

  /* Pre-seleccionar variante por talla del carrito + género */
  var matchVariant = null;
  for (var ci = 0; ci < bdefCartSizes.length; ci++) {
    var size       = bdefCartSizes[ci];
    var sizeGender = bdefCartSizeGender[size] !== undefined
      ? bdefCartSizeGender[size] : bdefCartGender;
    for (var vi = 0; vi < variants.length; vi++) {
      if (variants[vi].option1 === size &&
          variants[vi].available &&
          bdefProductMatchesGender(product, sizeGender)) {
        matchVariant = variants[vi]; break;
      }
    }
    if (matchVariant) break;
  }

  /* Auto-seleccionar en productos de talla única (bolsos, complementos…) */
  if (!matchVariant) {
    var available = variants.filter(function(v) { return v.available; });
    if (available.length === 1) {
      var ONE_SIZE = ['unica','unique','one size','os','osfa','talla unica'];
      if (ONE_SIZE.indexOf(bdefNormText(available[0].option1 || '')) !== -1) {
        matchVariant = available[0];
      }
    }
  }

  var displayVariant = matchVariant || baseVariant;

  /* Tallas únicas preservando orden del catálogo */
  var seen = {}, sizes = [];
  for (var si = 0; si < variants.length; si++) {
    if (!seen[variants[si].option1]) {
      seen[variants[si].option1] = true;
      sizes.push(variants[si]);
    }
  }


  /* Opciones del dropdown: disponibles primero, sin stock al final y deshabilitadas */
  var opts = sizes.map(function(v) {
    var avail   = v.available === true || v.available === 'true';
    var isMatch = matchVariant && v.id === matchVariant.id;
    return '<option value="' + v.id + '"' +
      ' data-price="' + v.price + '"' +
      ' data-compare-price="' + (v.compare_at_price || '') + '"' +
      (!avail ? ' disabled' : '') +
      (isMatch ? ' selected' : '') +
      '>' + bdefEscapeHtml(v.option1) + (!avail ? ' — sin stock' : '') + '</option>';
  }).join('');

  var selectEl =
    '<select class="bdef-recs__size-select" aria-label="Selecciona talla">' +
    (matchVariant ? '' : '<option value="" disabled selected>Selecciona talla</option>') +
    opts +
    '</select>';

  return '<li class="bdef-recs__item" data-product-id="' + product.id + '">' +
    '<a href="' + bdefEscapeHtml(product.url) + '" class="bdef-recs__image-link" tabindex="-1" aria-hidden="true">' +
    '<img src="' + bdefEscapeHtml(bdefResizeImage(product.featured_image || '', 180)) + '" alt="' + bdefEscapeHtml(product.title) +
    '" width="90" height="120" loading="lazy" class="bdef-recs__image"></a>' +
    '<div class="bdef-recs__body">' +
    '<p class="bdef-recs__vendor">'  + bdefEscapeHtml(product.vendor) + '</p>' +
    '<a href="' + bdefEscapeHtml(product.url) + '" class="bdef-recs__name">' + bdefEscapeHtml(product.title) + '</a>' +
    '<p class="bdef-recs__price" data-price-display>' +
    bdefPriceHTML(displayVariant.price, displayVariant.compare_at_price) + '</p>' +
    '<div class="bdef-recs__size-row">' +
    selectEl +
    '<button class="bdef-recs__atc"' + (matchVariant ? '' : ' disabled') +
    ' type="button" data-variant-id="' + (matchVariant ? matchVariant.id : '') + '">Añadir</button>' +
    '</div>' +
    '</div></li>';
}

/* ─── Eventos de los items de recomendación ─── */

function bdefBindRecsEvents(container) {

  /* Dropdown de talla */
  container.querySelectorAll('.bdef-recs__size-select').forEach(function(select) {
    select.addEventListener('change', function() {
      var item     = this.closest('.bdef-recs__item');
      var selected = this.options[this.selectedIndex];
      var priceEl  = item.querySelector('[data-price-display]');
      if (priceEl && selected.dataset.price) {
        priceEl.innerHTML = bdefPriceHTML(
          parseInt(selected.dataset.price),
          selected.dataset.comparePrice ? parseInt(selected.dataset.comparePrice) : null
        );
      }
      var btn = item.querySelector('.bdef-recs__atc');
      btn.dataset.variantId = this.value;
      btn.disabled          = !this.value;
    });
  });

  container.querySelectorAll('.bdef-recs__atc').forEach(function(btn) {
    btn.addEventListener('click', async function() {
      if (!this.dataset.variantId || this.disabled) return;
      var originalText = this.textContent;
      var self = this;
      this.disabled    = true;
      this.textContent = '\u2026';
      try {
        var addRes = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: Number(self.dataset.variantId), quantity: 1 })
        });
        if (!addRes.ok) throw new Error('Cart add failed: ' + addRes.status);
        var addedItem = await addRes.json();
        var cart      = await fetch('/cart.js').then(function(r) { return r.json(); });
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: addedItem.hasOwnProperty('items') ? addedItem.items : [addedItem],
            cart:  cart
          }
        }));
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
        self.textContent = '\u2713 A\u00f1adido';
        setTimeout(function() {
          self.textContent = originalText;
          self.disabled    = false;
        }, 1800);
      } catch(e) {
        console.warn('BDEF add to cart:', e);
        self.textContent = originalText;
        self.disabled    = false;
      }
    });
  });
}